/**
 * Strings for the Hub's text side (messages, the composer, mentions, the
 * channel header, history and jumps) added by the 2026-10-28 QA fixes.
 */
import type { Dict } from './core';

export const hubTextEn: Dict = {
  // mentions the reader can't resolve (never a raw ID)
  'ns.mention.noAccess': 'No access',
  'ns.mention.unknownUser': 'Unknown user',
  'ns.mention.deletedRole': 'Deleted role',
  'ns.mention.role': 'Notify everyone with this role',
  // the composer and the edit box
  'ns.cmp.maxFiles': {
    one: 'One message holds up to {max} images. {n} image was left out.',
    other: 'One message holds up to {max} images. {n} images were left out.',
  },
  'ns.msg.copyFailed': "Couldn't copy: the browser blocked the clipboard.",
  // sending too fast
  'ns.msg.rateLimited': "You're sending messages too fast. Sending again in {n} s.",
  'ns.msg.slowmode': 'Slowmode is on in this channel. Your message goes out in {n} s.',
  'ns.msg.waiting': 'Waiting to send… {n} s',
  // history
  'ns.hist.noPerm': "You don't have permission to read the message history of {name}.",
  'ns.hist.noPermSub': 'You see only the messages sent while you are here.',
  'ns.hist.older': "You're viewing older messages",
  'ns.hist.jumpPresent': 'Jump to present',
  // the channel header
  'ns.topic.open': 'Show the channel topic',
  'ns.topic.title': 'Channel topic',
  // voice channels' own chat
  'ns.ch.openChat': 'Open chat',
  // removed from the server
  'ns.hub.removed': 'You were removed from {name}.',
  'ns.hub.notMemberTitle': "You're not a member of the server",
  'ns.hub.notMember':
    "You're no longer a member, so its channels are gone. Your friends and direct messages still work.",
};
